import React from "react";

import { RetoolPromoCode } from "@/types/gql/graphql";
import BenefitsBanner from "./BenefitsBanner";
import DiscountBanner from "./DiscountBanner";

export enum BannerControllerPageType {
  blogHome = "blog_home",
  blogPost = "blog_post",
  mainHomePage = "mhp",
}

type Props = {
  page?: string | BannerControllerPageType;
  top?: boolean;
  promoCode?: RetoolPromoCode;
  lang: string;
};

export const BannersController: React.FC<Props> = ({
  top = false,
  page,
  promoCode,
  lang,
}) => {
  // Only show banners in English
  if (lang !== "en-us") return null;

  if (top) {
    switch (page) {
      case "gifts":
        return <BenefitsBanner />;
      case "membership-purchase-confirmation-shpfy":
        return <BenefitsBanner />;
      case "rum-membership-purchase-confirmation":
        return <BenefitsBanner />;
      case "gift-membership-purchase-confirmation-shpfy":
        return <BenefitsBanner />;
      case BannerControllerPageType.blogHome:
        return <BenefitsBanner />;
      default:
        return (
          <>
            <BenefitsBanner />
          </>
        );
    }
  } else {
    switch (page) {
      case BannerControllerPageType.blogHome:
        return <DiscountBanner promoCode={promoCode} />;
      default:
        return null;
    }
  }
};
